import React from "react";
import { ModalWrapper } from "../../../components/ui";
import { Button } from "../../../components/ui";

/**
 * Delete Shift Confirmation Modal
 * Displays a warning message and confirmation buttons for deleting a shift
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether the modal is open
 * @param {Function} props.onClose - Function to close the modal
 * @param {Function} props.onConfirm - Function to confirm deletion
 * @param {Object} props.shiftInfo - Optional shift information to display
 * @param {string} props.shiftInfo.date - Date of the shift
 * @param {string} props.shiftInfo.jobNum - Job number
 * @param {string} props.shiftInfo.startTime - Start time
 * @param {string} props.shiftInfo.finishTime - Finish time
 */
const DeleteShiftModal = ({ isOpen, onClose, onConfirm, shiftInfo }) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <ModalWrapper isOpen={isOpen} onClose={onClose}>
      <div className="text-center p-4">
        <div className="mb-4">
          {/* Warning Icon */}
          <div className="text-red-600 text-6xl mb-4">⚠️</div>
          
          {/* Warning Message */}
          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Delete Shift?
          </h2>
          
          <p className="text-gray-600 mb-2 font-semibold">
            This action cannot be undone.
          </p>
          
          <p className="text-gray-600 mb-4">
            You will need to clock in again to record a new shift.
          </p>

          {/* Optional shift info display */}
          {shiftInfo && (
            <div className="bg-gray-100 rounded-md p-3 mb-4 text-left">
              <p className="text-sm text-gray-700">
                <span className="font-semibold">Date:</span> {shiftInfo.date}
              </p>
              {shiftInfo.jobNum && (
                <p className="text-sm text-gray-700">
                  <span className="font-semibold">Job:</span> {shiftInfo.jobNum}
                </p>
              )}
              {shiftInfo.startTime && shiftInfo.finishTime && (
                <p className="text-sm text-gray-700">
                  <span className="font-semibold">Time:</span> {shiftInfo.startTime} - {shiftInfo.finishTime}
                </p>
              )}
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex gap-4 justify-center">
          <Button
            text="Cancel"
            variant="secondary"
            className="flex-1"
            onClick={onClose}
          />
          <Button
            text="Delete Shift"
            variant="warning"
            className="flex-1"
            onClick={handleConfirm}
          />
        </div>
      </div>
    </ModalWrapper>
  );
};

export default DeleteShiftModal;
